/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalErrorDocumento.css';

class ModalErrorDocumento extends React.Component {
  componentDidMount() {}
  render() {
    return (
      <div className="modal fade" id="ModalErrorDocumento">
        <div className="modal-dialog">
          <div className={`${s.modalContent} modal-content`}>
            <div className="modal-header">
              <h5 className="modal-title">Actualización de datos</h5>
            </div>
            <div className={`${s.modalBody} modal-body`}>
              <div>
                No es posible solicitar turnos para{' '}
                <span className={`${s.capitalize}`}>
                  {_.lowerCase(this.props.documento)}
                </span>{' '}
                dado que su DNI no está cargado correctamente. <br />Por favor
                comunicate al <strong>0810-444-7700</strong>
                <br /> para actualizar la información.
              </div>
            </div>
            <div className={`${s.modalFooter} modal-footer`}>
              <button
                data-dismiss="modal"
                className={`${s.boton_rojo} btn btn-danger text-center`}
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, null)(withStyles(s)(ModalErrorDocumento));



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalErrorDocumento/ModalErrorDocumento.js